import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { ChatType } from '@common/enums/ChatType';
import { DocumentStatus } from '@common/enums/DocumentStatus';
import { IChat } from '@common/models/Chat/IChat';
import { IDeltaTable } from '@common/models/Document/IDeltaTable';
import { Subject, Subscription, debounceTime, distinctUntilChanged } from 'rxjs';
import { MessageService } from 'primeng/api';
import { Router } from '@angular/router';
import { DocumentService } from '@app/services/document.service';
import { ChatServices } from '@app/services/chat.service';
import { IESGDocuments, IResponseESGFilters, ISourceURL } from '@common/models/Document/IESGDocuments';
import { ITableTag } from "@common/models/ITags";
import { IChatConfig, IESGConfig } from '@common/models/Chat/IChatConfig';
import { getRouteParamChatType } from '@app/utils';

@Component({
  selector: 'app-esgdata-main',
  templateUrl: './esgdata-main.component.html',
  styleUrls: ['./esgdata-main.component.scss']
})
export class EsgdataMainComponent implements OnInit, OnDestroy, OnChanges {

  constructor(
    private readonly docService: DocumentService,
    private readonly chatService: ChatServices,
    private readonly messageService: MessageService,
    private readonly router: Router,
    private readonly cdr: ChangeDetectorRef,
  ) {
    this.searchTextUpdate
    .pipe(debounceTime(500), distinctUntilChanged())
    .subscribe({
        next: (value) => {
            if (this.searchText.trim() != '' ) {
                this.isESGFilterLoading = true;
                this.ESGDocumentNameList = this.ESGDocumentNameList.filter(document =>
                  document.documentName.toLowerCase().includes(this.searchText.toLowerCase())
                );
                this.isESGFilterLoading = false
            }
            else if((this.searchText.length==0 && value.key=="Backspace")){
                this.isESGFilterLoading = false
                this.updateFiltersSource()
            }
        }
    });
  }

  getAllDocsSub: Subscription = new Subscription();
  getUnqCategoriesSub: Subscription = new Subscription();
  createChatSub: Subscription = new Subscription();
  updateChatTablesSub: Subscription = new Subscription();
  getESGTableTagsSubscription: Subscription = new Subscription();
  getESGDocsSub: Subscription = new Subscription();
  isloading: boolean = true;
  pageSize: number = 15;
  showLoadMore: boolean = true;
  loadmoreLoading: boolean = false;
  documentProcessing: DocumentStatus = DocumentStatus.Processing;
  documentProcessed: DocumentStatus = DocumentStatus.Processed;
  documentArchived: DocumentStatus = DocumentStatus.Archived;
  documentFailed: DocumentStatus = DocumentStatus.Failed;
  tablesList: IDeltaTable[] = [];
  selectedTables: IDeltaTable[] = [];
  searchText: string;
  activeChat: IChat;
  searchTextUpdate = new Subject<any>();
  scrollUpdate = new Subject<any>();
  sidebarVisible: boolean = false;
  summaryData: string = '';
  headerSummary: string;
  dialogType: 'table' | 'document';
  summaryDocumentName:string;
  deltaTableForSummary:IDeltaTable;
  activeTabIndex:number =0;

  unqTableCategories :string[] = [];
  tablesListByCategory :any[] = []

  isESGFilterLoading:boolean = false;
  ESGDocumentNameList : IESGDocuments[] = []
  ESGOriginalDocumentNameList : IESGDocuments[] = []
  selectedESGDocumentsList : IESGDocuments[] = []
  chatwithDocs: boolean = false;
  selectedESGTags: ITableTag[]=[];
  ESGtagsList : ITableTag[]=[];
  selectedESGSourceType : ISourceURL[] = []
  ESGSourcesList :ISourceURL[] = []
  ESGOriginalSourcesList :ISourceURL[] = []
  summarySidebarVisible: boolean = false;
  ESGDocumentLoaderDocs : Record<number,boolean> = {}
  @Input() visible: any;
  @Output() visibleChange = new EventEmitter<boolean>(); // Emits changes
  @Input() activeChatParent: IChat;
  selectedTagsLabel:string="Select Tags"
  selectedSourceLabel:string="Select Source"



    closeDialog() {
      this.chatwithDocs = false;
      this.visibleChange.emit(false); // Notify parent that dialog is closed
    }

  ngOnInit(): void {
    this.getUniqueCategoriesTables()
    this.getESGTableTags()
  }

  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    if (!changes['activeChatParent']) return;

    const newChat = changes['activeChatParent'].currentValue;
    if (!newChat) {
        this.selectedESGDocumentsList = [];
        this.selectedTables=[]
        this.selectedESGTags=[]
        this.selectedESGSourceType=[]
        this.activeChat=undefined
        return;
    }

    if (!this.activeChat || this.activeChat.chatId !== newChat.chatId) {
        this.isloading = true;
        this.activeChat = newChat;
        this.selectedESGDocumentsList = [];
        this.selectedTables=[]
        this.selectedESGTags=[]
        this.selectedESGSourceType=[]

        this.onMultiSelectOpen()
        let tempselectedDocs: ISourceURL[] = newChat?.chatConfig?.ESGChat?.ESGDocuments || [];
        if (tempselectedDocs.length > 0) {
            if (this.ESGDocumentNameList?.length === 0) {
                await this.getESGTableTags();
            }
            this.selectedESGDocumentsList = this.ESGDocumentNameList.filter(doc =>
                tempselectedDocs.some(e => e.documentId === doc.documentId)
            );
        }

        let tempselectedTables = newChat.chatTables || [];
        for (const e of tempselectedTables) {
            const categoryObj = this.tablesListByCategory.find(cat => cat.category === e.category);
            if (categoryObj) {
                if (!categoryObj.tables?.length) {
                    await this.onRowExpand({ data: { category: categoryObj.category } });
                }
                this.selectedTables.push(...categoryObj.tables.filter(catTable => catTable.tableId === e.tableId));
            }
        }



        this.isloading = false;
        this.updateSourceDropDownCount()
        this.updateTagsDropDownCount()
    }
}


  ngOnDestroy() {
    this.getAllDocsSub?.unsubscribe();
    this.createChatSub?.unsubscribe();
    this.updateChatTablesSub?.unsubscribe();
    this.getESGTableTagsSubscription?.unsubscribe();
    this.getESGDocsSub?.unsubscribe();
  }

  updateSidebar(value: boolean) {
    this.sidebarVisible = value;
  }

  showAbout(deltaTableModel:IDeltaTable) {
    let aboutText = deltaTableModel.dataDictionary;
    this.dialogType = 'table';
    this.sidebarVisible = true;
    this.summaryData = JSON.stringify(aboutText);
    this.summaryDocumentName = deltaTableModel.tableName
    this.deltaTableForSummary = deltaTableModel
    this.headerSummary = 'About';
  }

  showESGSUmmary(docModel:IESGDocuments) {
    this.dialogType = 'document';
    this.sidebarVisible = true;
    this.summaryData = docModel.documentSummary
    this.summaryDocumentName = docModel.documentName
    this.headerSummary = 'Summary';
  }

  async checkChatDocs() {
    this.chatwithDocs = true;
    if(this.activeChat){
      this.chatService.updateChatTypeStatus(ChatType.ESG)
      if(this.selectedTables.length>0 || this.selectedESGDocumentsList.length > 0 || this.selectedESGSourceType.length>0||this.selectedESGTags.length>0){
        this.attachChatstoDocs(this.selectedTables)
        return;
      }
    }
    this.activeChat = undefined
    this.chatService.updateChatTypeStatus(ChatType.ESG)
    this.createNewChat();
  }

  createNewChat() {
    this.createChatSub = this.chatService.createNewChat().subscribe({
        next: (res: IChat) => {
            this.activeChat = res;
            this.activeChat.chatTables = this.selectedTables;
            if(this.selectedTables.length>0 || this.selectedESGDocumentsList.length > 0 || this.selectedESGSourceType.length>0||this.selectedESGTags.length>0){
              this.attachChatstoDocs(this.selectedTables)
            }

            void this.router.navigate(['/chat', getRouteParamChatType(this.chatService.chatType), this.activeChat.chatId]);
        }
    });
}

attachChatstoDocs(chatTables:IDeltaTable[]){
  let chatConfig: IChatConfig = {}
  let selectedTablesTags :ITableTag[] = this.selectedESGTags || []

  if( this.selectedESGDocumentsList.length > 0 || this.selectedESGSourceType.length>0 ){
    if(this.selectedESGSourceType.length > 0 && this.selectedESGDocumentsList.length == 0){
      const sourceList = new Set(this.selectedESGSourceType.map((e: ISourceURL) => e.sourceType));
      this.ESGOriginalDocumentNameList.forEach((e:IESGDocuments)=>{
        if(sourceList.has(e.sourceType)){
          this.selectedESGDocumentsList.push(e)
        }
      })
    }
    let tempESGConfig:IESGConfig = {
      ESGSources : this.selectedESGSourceType|| [],
      ESGDocuments : this.selectedESGDocumentsList || []
    }
    chatConfig.ESGChat =tempESGConfig
  }
  this.updateChatTablesSub.add(
      this.chatService
          .updateChatDocuments([],
              this.activeChat.chatId,
              chatTables,selectedTablesTags, chatConfig
          )
          .subscribe({
              next: (res) => {
                  this.activeChat = res?.data;
                  this.chatService.updateActiveChatObs(res?.data);
                  this.chatService.updateActiveChat(res?.data);
                  this.closeDialog()
                  if(res?.message?.trim() != ''){
                    this.messageService.clear();
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: res?.message,
                    });
                  }
              },
              error: (error) => {
                  this.messageService.clear();
                  this.messageService.add({
                      severity: 'error',
                      summary: 'Error',
                      detail: error.error.message,
                  });
              },
          })
  );
}

  getUniqueCategoriesTables(){
    this.getUnqCategoriesSub.add(
      this.docService.getUniqueESGTableCategories().subscribe({
        next:(response:string[] )=>{
          this.unqTableCategories = response
          this.unqTableCategories.forEach((e:string)=>{
                this.tablesListByCategory.push({
                  category : e,
                  tables: [],
                  categorySelection : false
                })
          })
          this.isloading = false;
        },
        error(err) {
          console.log(err)
          this.loadmoreLoading = false;
          this.isloading = false;
        },
      })
    )
  }

  async getListOfTablesForCategory(category: string): Promise<IDeltaTable[]> {
    return new Promise((resolve, reject) => {
      this.docService.getListOfESGTablesForCategory(category).subscribe({
        next: (response: IDeltaTable[]) => {
          resolve(response);
        },
        error: (err) => {
          console.log(err);
          this.loadmoreLoading = false;
          this.isloading = false;
          reject(err);
        },
      });
    });
  }

  async onRowExpand(event) {
    const category = event.data.category;
    const categoryIndex = this.tablesListByCategory.findIndex(table => table.category === category);

    if (categoryIndex !== -1 && this.tablesListByCategory[categoryIndex].tables.length === 0) {
      const catTablesList = await this.getListOfTablesForCategory(category);
      this.tablesListByCategory[categoryIndex].tables = catTablesList;
    }
  }

  selectCategoryRows(category: string, tables: IDeltaTable[]): void {
    tables.forEach(row => {
      if (!this.selectedTables.includes(row)) {
        this.selectedTables=[...this.selectedTables, row];
      }
    });
  }

  deselectCategoryRows(category: string): void {
    this.selectedTables = this.selectedTables.filter(row => row.category !== category);
  }

  checkMultipleSourcesSelection(){
    let isDisabled = false;
    if(this.selectedTables.length > 0){
        let selectedSource = this.selectedTables[0].source
        this.selectedTables.forEach((e:IDeltaTable)=>{
          if(selectedSource !== e.source){
            isDisabled = true
          }
      })
    }
    return isDisabled
  }


  //ESG Docs

  async getESGTableTags(){
    this.isESGFilterLoading = true
      this.getESGTableTagsSubscription.add(
        this.chatService
            .getESGDocuments()
            .subscribe({
                next: (
                    table: IResponseESGFilters
                ) => {
                    this.isESGFilterLoading = false
                    if (table.sourceURL) {
                      this.filterUniqueSourceTypes(table.sourceURL)
                      this.ESGDocumentNameList = table.sourceURL;
                      this.ESGOriginalDocumentNameList =  structuredClone(this.ESGDocumentNameList);
                    }
                    if ( table.documentTags) {
                      this.ESGtagsList = []
                      let tags : any = table.documentTags
                        tags.forEach((e:ITableTag)=>{
                            this.ESGtagsList.push({tag:e.tag})
                        })
                      }
                },
                error: (
                    error
                ) => {
                },
            })
    );
  }

  filterUniqueSourceTypes(SourceUrls : IESGDocuments[]){
    const uniqueSourceTypes = new Set<string>();
    this.ESGSourcesList = []
    this.ESGOriginalSourcesList = []
    SourceUrls.forEach((doc : IESGDocuments) => {
        if (!uniqueSourceTypes.has(doc.sourceType)) {
            uniqueSourceTypes.add(doc.sourceType);
            this.ESGSourcesList.push({'sourceType':doc.sourceType});
            this.ESGOriginalSourcesList.push({'sourceType':doc.sourceType});
        }
    });
  }

  onMultiSelectOpen(){
    if(this.activeChat?.ESGTableTags?.length>0 && this.selectedESGTags.length === 0){
      this.selectedESGTags = []
      this.activeChat.ESGTableTags.forEach((e:ITableTag)=>{
        this.selectedESGTags = [...this.selectedESGTags, {tag:e.tag}]
      })
      this.updateTagsDropDownCount()
    }
      if(this.selectedESGSourceType.length === 0 &&  this.activeChat?.chatConfig?.ESGChat?.ESGSources && this.activeChat.chatConfig.ESGChat.ESGSources.length > 0){
        this.selectedESGSourceType = [...this.activeChat.chatConfig.ESGChat.ESGSources.map((e:ISourceURL)=>{return {'sourceType':e.sourceType}})]
        this.updateSourceDropDownCount()
    }

  }

updateSourceDropDownCount(){
  if(this.selectedESGSourceType.length>0){
    this.selectedSourceLabel = 'Selected: '+this.selectedESGSourceType.length+'*'
  }else{
      this.selectedSourceLabel = 'Select Source'
  }
  this.cdr.detectChanges();
}

updateTagsDropDownCount(){
  if(this.selectedESGTags.length>0){
    this.selectedTagsLabel = 'Selected: '+this.selectedESGTags.length+'*'
  }else{
      this.selectedTagsLabel = 'Select Source'
  }
  this.cdr.detectChanges();

  if(this.selectedESGTags.length > 0){
    // Extract the tag strings from selected tag objects
    const selectedTagStrings = new Set(this.selectedESGTags.map((e: ITableTag) => e.tag));

    // Filter documents that contain at least one of the selected tags
    this.ESGDocumentNameList = this.ESGOriginalDocumentNameList.filter(doc =>
      doc.tags.some(tag => selectedTagStrings.has(tag))
    );

    // Also filter selected documents based on selected tags
    this.selectedESGDocumentsList = this.selectedESGDocumentsList.filter(doc =>
      doc.tags.some(tag => selectedTagStrings.has(tag))
    );
  }else{
    this.ESGDocumentNameList = this.ESGOriginalDocumentNameList
  }

}

  updateFiltersSource(isClear?:boolean){
    if(isClear){
      this.selectedESGSourceType = []
    }
     this.updateSourceDropDownCount()
      if (this.selectedESGSourceType.length > 0) {
          const sourceList = new Set(this.selectedESGSourceType.map((e: ISourceURL) => e.sourceType));
          this.ESGDocumentNameList = this.ESGOriginalDocumentNameList.filter(e => sourceList.has(e.sourceType));
          if(this.selectedESGDocumentsList.length){
            this.selectedESGDocumentsList = [...this.selectedESGDocumentsList.filter(e => sourceList.has(e.sourceType))]
          }
      }else{
        this.ESGDocumentNameList = this.ESGOriginalDocumentNameList
      }


      this.isESGFilterLoading = false
  }

  updateFiltersDocuments(isClear?:boolean){
    if(isClear){
      this.selectedESGDocumentsList = []
    }
    if(this.selectedESGDocumentsList.length > 0){
      const sourceList = new Set(this.selectedESGDocumentsList.map((e: ISourceURL) => e.sourceType));
      const selectedSourceList = new Set(this.selectedESGSourceType?.map((e: ISourceURL) => e.sourceType));
      this.selectedESGSourceType = [
        ...this.selectedESGSourceType,
        ...Array.from(sourceList)
          .filter((source: string) => !selectedSourceList.has(source))
          .map((source: string) => ({ sourceType: source }))
      ];
    }else{
      this.ESGSourcesList = this.ESGOriginalSourcesList
    }
    this.updateSourceDropDownCount()
  }

  updateFiltersDocsBatch(){
    if(this.selectedESGDocumentsList.length > 0){
      this.selectedESGSourceType = [...this.ESGSourcesList]
    }else{
      this.selectedESGSourceType = []
    }
    this.updateSourceDropDownCount()
  }

  openESGSummary(ESGDocument:IESGDocuments){
    this.headerSummary = 'Summary'
    this.dialogType = 'document';
    this.summaryDocumentName = ESGDocument.documentName
    this.getESGDocsSub = this.chatService.getESGDocumentByID(ESGDocument.documentId)
      .subscribe({
          next: (res: IESGDocuments) => {
            this.ESGDocumentLoaderDocs = {}
            this.summaryData = res.documentSummary
            this.summarySidebarVisible = true;
          }
      });
  }


}
